import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_SK.json';
import audios from './LOVE_AUDIOS_SK.json';

export const LOVE_DATA_SK: ServiceData = {
  articles,
  audios,
};
